import MarkdownMessage from '@gluedigital/markdown-message';
import { FormattedMessage } from 'react-intl';
import WidgetAvatar from 'src/components/Widget/WidgetAvatar/WidgetAvatar';
import { useClientConfig } from 'src/hooks/useClientConfig';
import { useIsMobile } from 'src/hooks/useIsMobile';
import { BotMessage as BotMessageType, UserMessage } from 'src/types';
import AvatarAnimation from '../../AvatarAnimation/AvatarAnimation';
import SourcesMobile from '../../SourcesMobile/SourcesMobile';
import BotMessageFooter from '../BotMessageFooter';
import FormattedText from '../FormattedText/FormattedText';
import TypingText from '../TypingText/TypingText';

import 'src/components/modals/ShareModal/ShareModal';
import 'src/components/modals/FeedbackModal/FeedbackModal';

const BotMessage = ({ message, replyTo }: { message: BotMessageType; replyTo: UserMessage }) => {
	const isMobile = useIsMobile();
	const client = useClientConfig();
	const { text, sources, completed, id, outdated, error, internetSources } = message;

	let messageContent;

	if (!text) {
		messageContent = <TypingText />;
	} else if (error) {
		messageContent = (
			<span>
				<FormattedMessage id={`${text}`} />
			</span>
		);
	} else {
		messageContent = <FormattedText text={text.replace(/\.\./g, '.')} />;
	}

	return (
		<article className="chat-message bot-message">
			<div className={`message-wrapper ${outdated ? 'with-oudated' : ''}`}>
				{client ? <WidgetAvatar /> : !completed ? <AvatarAnimation /> : <span className="bot-avatar" />}
				<div className="text">
					{outdated && (
						<span className="warning-outdated">
							<MarkdownMessage id="warning.outdated" />
						</span>
					)}

					{messageContent}

					{isMobile && !!(sources?.filter((s) => s.position) || [])?.length && (
						<SourcesMobile sources={sources} internetSources={internetSources} messageId={id} />
					)}
					{completed && !error && <BotMessageFooter typing={!completed || text === ''} message={message} replyTo={replyTo} />}
				</div>
			</div>
		</article>
	);
};

export default BotMessage;
